import axios from "axios";
import router from "@/router";


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async isProjectExpire({commit}) {
            const res = await axios.get(`/check-site-is-expire`);
            let baseData = res.data.data
            let is_server_charge_expire = baseData.is_server_charge_expire
            if (is_server_charge_expire) {
                router.push({name: 'Suspend'})
            }
            return res
        },
    },
    getters: {},
}